
import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import AdminAuthFormComponent from '../../components/forms/auth-admin.form.vue';
import AdminTabsFormComponent from '../../components/forms/tabs-admin.form.vue';
import { IPark } from '@/models/IPark.model';
import { ParksAPI } from '@/apis/parks.api';

@Component({
  components: {
    'admin-auth-form': AdminAuthFormComponent,
    'admin-tabs-form': AdminTabsFormComponent,

  },
})
export default class Home extends Vue {

  public isAuth: boolean = false;
  public parks: IPark[] = []

  private async mounted(){
      const parksApi = new ParksAPI();
      const parks = await parksApi.getAll();
      this.parks = parks;

      if(location.href.includes('localhost')){
        this.isAuth =  true
      }
      console.error(' ')
      console.error('this.parks ')
      console.error(this.parks)
      console.error(' ')
  }

  onAuthSucceed(){
    this.isAuth = true
  }
  onAuthFailed(){
    this.isAuth = false
    }
   async updateParks(){
      const parkApi = new ParksAPI();
      const parks = await parkApi.getAll();
      this.parks = parks;
    }

}